import {
  LOGIN,
  LOGOUT,
  USER_CREATED,
  SET_PROPERTY_USER,
  SET_PROPERTY_LOGIN,
} from "../types/usuario";
import { SHOW_SPINNER, HIDE_SPINNER, SHOW_ALERT } from "../actions/types";

const INITIAL_STATE = {
  user: {},
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOGIN:
      return { ...state, user: payload, spinner: false, logout: false };
    case LOGOUT:
      return { ...state, user: null, logout: true };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case USER_CREATED:
      return { ...state, created: true };
    case SHOW_ALERT:
      return { ...state, error: payload };
    case SET_PROPERTY_USER: {
      const { key, value } = payload;
      const user = { ...state.user };
      user[key] = value;
      return { ...state, user };
    }
    case SET_PROPERTY_LOGIN:
      const { key, value } = payload;
      return { ...state, [key]: value };
    default:
      return { ...state };
  }
};
